<script context="module">
    import {get} from "svelte/store";
    import {componentName} from "./stores/store";

    export const bxSubmit = (iblock, event, formData, captchaToken) => {
        return new Promise((resolve) => {
            BX.ajax.runComponentAction(get(componentName), 'submit', {
                mode: 'class',
                data: {
                    iblock,
                    event,
                    formData,
                    // Верхнеуровневый ключ: именно так его читает YandexCaptcha::validate()
                    // через $request->get('smart-token'); внутрь formData не кладём —
                    // там разбираются коды свойств инфоблока.
                    'smart-token': captchaToken
                }
            }).then(response => {
                console.log(response.data);
                if (response.status === "success") {
                    resolve(response.data);
                } else {
                    resolve({error: 'Ошибка.'})
                }
            }).catch(error => {
                console.log(error);
            });
        });
    }
</script>